export const generateKankanFilterDate = (kanbanData: any[]) => {
  return kanbanData.map((pipeline: any) => ({
    ...pipeline,
    cardList: pipeline.cardList.map((card: any) => ({
      ...card,
      filterData:
        pipeline.id === 10 || pipeline.id === 11
          ? card.investedAt
          : card.nextAt,
    })),
  }))
}
